import { ReactElement } from 'react';
import { MODULE } from '../../../common';
import { useTranslation } from '@jobcost-monorepo/i18n';
import React from 'react';

interface Props {
  moduleName: MODULE;
}

const CrudTitle = ({ moduleName }: Props): ReactElement => {
  const { t } = useTranslation(moduleName.toLocaleLowerCase());

  return (
    <div>
      <p className="text-pink text-2xl">{t(`form.${moduleName}`)}</p>
    </div>
  );
};

export default CrudTitle;
